import React, { useState } from 'react';
import { Group, Modal, Radio, Stack, Text, TextInput } from '@mantine/core';
import { Button } from '../../../../../components/Button';
import { roundMoney } from 'shared-models/browser';
import { formatMoney } from '../../../../../utils/money';
import type { OrderlineView } from '../../../../../services/orderlines/orderlines.service';
import type { getComboMoveTargets } from './useMoveSentItemIntoCombo';

export function MoveSentItemIntoComboModal({ source, targets, busy, onClose, onConfirm }: {
  source: OrderlineView; targets: ReturnType<typeof getComboMoveTargets>; busy: boolean;
  onClose: () => void; onConfirm: (selectionId: number) => Promise<void>;
}) {
  const [selectionId, setSelectionId] = useState('');
  const [search, setSearch] = useState('');
  const visible = targets.filter((target) => `${target.line.productName} ${target.selection.itemName}`.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase()));
  const selected = visible.find((target) => String(target.selection.selectionId) === selectionId);
  const discount = source.discountInput ?? 0;
  const before = selected ? source.unitPrice * source.quantity - discount + selected.line.unitPrice - (selected.line.discountInput ?? 0) : 0;
  const after = selected ? before - source.unitPrice + discount - roundMoney(discount * (source.quantity - 1) / source.quantity) : 0;
  return <Modal opened onClose={onClose} title="העבר לעסקה" centered closeOnClickOutside={!busy} closeOnEscape={!busy} withCloseButton={!busy}>
    <Stack gap="md" dir="rtl">
      <Text fw={600}>{source.productName} × 1</Text>
      {source.note && <Text size="sm">{source.note}</Text>}
      {(source.selectionLabels ?? []).map((label, index) => <Text size="sm" key={`${index}-${label}`}>{label}</Text>)}
      <TextInput aria-label="חיפוש בעסקאות" placeholder="חיפוש בעסקאות" value={search} disabled={busy}
        onChange={(event) => setSearch(event.currentTarget.value)} onContextMenu={(event) => event.preventDefault()}
        styles={{ input: { userSelect: 'none', WebkitUserSelect: 'none', WebkitTouchCallout: 'none' } }} />
      <Radio.Group value={selectionId} onChange={setSelectionId}><Stack gap="sm">
        {visible.map((target) => <Radio key={target.selection.selectionId} value={String(target.selection.selectionId)} disabled={busy}
          label={`${target.line.productName} / ${target.selection.groupName}: ${target.selection.itemName}`} />)}
      </Stack></Radio.Group>
      {visible.length === 0 && <Text size="sm">אין רכיבים ממתינים תואמים.</Text>}
      {selected && <Group justify="space-between"><Text>לפני: {formatMoney(roundMoney(before))}</Text><Text fw={600}>אחרי: {formatMoney(roundMoney(after))}</Text></Group>}
      <Group justify="flex-end">
        <Button variant="cancel" disabled={busy} onClick={onClose}>ביטול</Button>
        <Button variant="confirm" dataTestId="combo-move-confirm" disabled={!selected || busy} loading={busy} onClick={() => selected ? onConfirm(selected.selection.selectionId!) : undefined}>אישור</Button>
      </Group>
    </Stack>
  </Modal>;
}